import React from 'react';
import './Index.scss';
import useLocales from 'hooks/useLocales';
import PageHeader from 'components/PageHeader';

const UrlExpired = () => {
  const { t } = useLocales();
  return (
    <>
      <PageHeader />
      <div className="error-page__container">
        <div className="error-page__box">
          <h2 className="error-page__title">{t('URL Expired')}</h2>
          <div className="error-page__message">
            {t('The link you followed has expired or is no longer valid.')}
          </div>
        </div>
      </div>
    </>
  );
};

export default UrlExpired;
